var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIconSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 37.9856,
    rx: 8,
    fill: "#F6830E",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.543 10H23.2654C22.4726 10 21.8218 10.6508 21.8218 11.4436V15.6797H17.0769C16.3078 15.6797 15.6806 16.3068 15.6806 17.0878V21.8327H11.4091C10.6281 21.8327 10.001 22.4598 10.001 23.2408V26.5539C10.001 27.3349 10.6281 27.962 11.4091 27.9857H26.5548C27.3476 27.9857 27.9984 27.3349 27.9984 26.5421V11.4436C27.9866 10.6508 27.3358 10 26.543 10Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.543 10H23.2654C22.4726 10 21.8218 10.6508 21.8218 11.4436V15.6797H17.0769C16.3078 15.6797 15.6806 16.3068 15.6806 17.0878V21.8327H11.4091C10.6281 21.8327 10.001 22.4598 10.001 23.2408V26.5539C10.001 27.3349 10.6281 27.962 11.4091 27.9857H26.5548C27.3476 27.9857 27.9984 27.3349 27.9984 26.5421V11.4436C27.9866 10.6508 27.3358 10 26.543 10Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5432 10H23.2893C22.4965 10 21.8457 10.6508 21.8457 11.4436V27.9857H26.5432C27.336 27.9857 27.9868 27.3349 27.9868 26.5421V11.4436C27.9868 10.6508 27.336 10 26.5432 10Z",
    fill: "#F57C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6806 17.0996V21.8326H11.4209C10.6399 21.8326 10.001 22.4716 10.001 23.2525V26.5657C10.001 27.3466 10.6399 27.9856 11.4209 27.9856H21.8336V15.6797H17.1006C16.3196 15.6797 15.6806 16.3186 15.6806 17.0996Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.834 15.6797V27.9856H26.5316C27.3244 27.9856 27.9752 27.3348 27.9752 26.542V21.8326L21.834 15.6797Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1006 15.798H21.8337V15.6797H17.1006C16.3196 15.6797 15.6807 16.3187 15.6807 17.0996V17.2179C15.6807 16.437 16.3196 15.798 17.1006 15.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.4209 21.951H15.6806V21.8326H11.4209C10.6399 21.8326 10.001 22.4716 10.001 23.2526V23.371C10.001 22.59 10.6399 21.951 11.4209 21.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.5441 10H23.2902C22.4975 10 21.8467 10.6508 21.8467 11.4436V11.5619C21.8467 10.7691 22.4975 10.1183 23.2902 10.1183H26.5441C27.3369 10.1183 27.9876 10.7691 27.9876 11.5619V11.4436C27.9876 10.6508 27.3369 10 26.5441 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.543 27.8674H11.4209C10.6399 27.8674 10.001 27.2284 10.001 26.4474V26.5657C10.001 27.3467 10.6399 27.9857 11.4209 27.9857H26.5312C27.3239 27.9857 27.9747 27.3349 27.9747 26.542V26.4237C27.9866 27.2166 27.3358 27.8674 26.543 27.8674Z",
    fill: "#BF360C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.543 10H23.289C22.4962 10 21.8454 10.6508 21.8454 11.4436V15.6797H17.1124C16.3314 15.6797 15.6925 16.3186 15.6925 17.0996V21.8327H11.4209C10.6399 21.8327 10.001 22.4716 10.001 23.2526V26.5657C10.001 27.3467 10.6399 27.9857 11.4209 27.9857H26.543C27.3358 27.9857 27.9866 27.3349 27.9866 26.5421V11.4436C27.9866 10.6508 27.3358 10 26.543 10Z",
    fill: "url(#paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.001,
    y1: 18.9928,
    x2: 27.9984,
    y2: 18.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10.001,
    y1: 18.9928,
    x2: 27.9984,
    y2: 18.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18.7871,
    y1: 18.7857,
    x2: 27.5562,
    y2: 27.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF360C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF360C",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 16.032,
    y1: 16.0383,
    x2: 27.6665,
    y2: 27.6729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.9856,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIconSmall);
export default __webpack_public_path__ + "static/media/GoogleIcon_small.cdd0aef7.svg";
export { ForwardRef as ReactComponent };